
export const FETCH_INVEST_REQUEST = 'FETCH_INVEST_REQUEST';
export const FETCH_INVEST_SUCCESS = 'FETCH_INVEST_SUCCESS';
export const FETCH_INVEST_FAILURE = 'FETCH_INVEST_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';